// Proposed edits are anchored by a verbatim substring of the article, which the
// server has already checked is unique. It can stop being unique once an earlier
// edit in the same batch has rewritten the text, so re-check before applying.
export const findsOnce = (text, needle) => {
  if (!needle) return false;
  const first = text.indexOf(needle);
  return first !== -1 && first === text.lastIndexOf(needle);
};

// Applies in order, skipping any anchor a previous edit invalidated. Returns the
// new markdown plus the edits that actually landed, so the panel can mark the
// rest as stale instead of silently dropping them.
//
// The callback form of replace() is deliberate: with a string replacement, `$&`
// or `$1` occurring in the article text would be treated as a substitution
// pattern instead of literal characters.
export const applyEditsTo = (markdown, edits) => {
  let text = markdown;
  const applied = [];
  for (const edit of edits) {
    if (!findsOnce(text, edit.find)) continue;
    text = text.replace(edit.find, () => edit.replace);
    applied.push(edit);
  }
  return { text, applied };
};
